/* eslint-disable */
import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopMentoring(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_approval" popSize="s">
      <h2 className="pop_tit">승인</h2>
      <div className="content_container scroll">
        <div className="radio_wrap">
          <div className="check">
            <input type="radio" name="approval" id="approval01" className="com_chk circle" />
            <label htmlFor="approval01">승인</label>
          </div>
          <div className="check">
            <input type="radio" name="approval" id="approval02" className="com_chk circle" />
            <label htmlFor="approval02">미승인</label>
          </div>
          <div className="check">
            <input type="radio" name="approval" id="approval03" className="com_chk circle" />
            <label htmlFor="approval03">멘토패스</label>
          </div>
        </div>
      </div>
      <div className="btn_container">
        <button onClick={close} className="com_btn orange xs">
          확인
        </button>
      </div>
    </Modal>
  );
}

export default PopMentoring;
